import $ from 'jquery';

export default function selectBoxModule() {
  const selectBoxElement = $('.select');
  if (selectBoxElement.length) {
    return import(/* webpackChunkName: "select-box" */ '../selectbox')
      .then(({ default: SelectBox }) => {
        const selectBox = new SelectBox();
        return selectBox;
      })
      .catch(() => 'An error occurred while loading the component');
  }
  return null;
}
